/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { StyledCheckbox } from './Item';

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(2),
    },
  },
  divider: {
    border: 0,
    borderStyle: 'solid',
    borderTop: 1,
    margin: 0,
    width: '100%',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  titleBar: {
    alignItems: 'center',
    display: 'flex',
    height: 42,
  },
  titleBarItem: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: 120,
  },
}));

export default ({
  onSelectAllCheckboxChange,
  onGoBackClick,
  isReadOnly,
  isSelectAllChecked,
}) => {
  const classes = useStyle();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        <div onClick={onGoBackClick} style={{ flexBasis: 0, flexGrow: 1 }}>
          ◀
          {' '}
          {t('ec.go_back_and_shop')}
        </div>
        <div style={{ flexBasis: 0, flexGrow: 1, textAlign: 'center' }}>
          {t('ec.cart_list')}
        </div>
        <div style={{ flexBasis: 0, flexGrow: 1 }} />
      </div>
      <hr className={classes.divider} style={{ marginTop: 24 }} />
      <div className={classes.titleBar}>
        <div style={{ justifyContent: 'start', flexGrow: 1 }}>
          {isReadOnly
            ? t('ec.purchase_products')
            : (
              <>
                <StyledCheckbox id="selectAll" checked={isSelectAllChecked} onChange={onSelectAllCheckboxChange} />
                <label htmlFor="selectAll">{t('ec.select_all_from_cart')}</label>
              </>
            )}
        </div>
        <div className={classes.titleBarItem}>
          {t('ec.purchase_amount')}
        </div>
        <div className={classes.titleBarItem}>
          {t('ec.total')}
        </div>
      </div>
      <hr className={classes.divider} />
    </div>
  );
};
